// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__l2Zgc","margin":"styles_margin__gURBM","subtitle":"styles_subtitle__BWush","dark":"styles_dark__hJab7"};